<template>
  <iColumn align="center">
    <iText>Enter your email address to reset your password</iText>
    <iTextInput
      v-model="userAuthEmail"
      width="fill"
      right-icon="pencil"
      focus
    />
    <iText v-if="forgotPasswordErrorMessage" variant="error">
      {{ forgotPasswordErrorMessage }}
    </iText>
    <iButton
      :is-loading="isLoading"
      loading-spinner-position="inside"
      :disabled="isLoading"
      @click="submitForgotPassword"
    >
      Continue
    </iButton>
    <iLink @click="goBackToLogin">
      Back to login
    </iLink>
    <iSpace :height="40" width="fill" />
    <PoweredByInspiration />
  </iColumn>
</template>

<script>
import PoweredByInspiration from "%/dynamic-component-editor/standard-pages/login-signup-page/join-publication/PoweredByInspiration.vue";
import { mapActions, mapState, mapWritableState } from "pinia";
import { useLoginSignupStore } from "%/dynamic-component-editor/stores/login-signup-store";

export default {
  name: "JoinPublicationForgotPassword",
  components: { PoweredByInspiration },
  computed: {
    ...mapWritableState(useLoginSignupStore, ["userAuthEmail", "userFlowSteps", "forgotPasswordErrorMessage"]),
    ...mapState(useLoginSignupStore, ["isLoading"]),
  },
  methods: {
    ...mapActions(useLoginSignupStore, ["forgotPassword"]),
    submitForgotPassword() {
      this.forgotPassword(1);
    },
    goBackToLogin() {
      this.userFlowSteps.pop();
    },
  },
};
</script>
